module.exports = __webpack_public_path__ + "static/media/Gilroy-UltraLight-Italic.b3955919.ttf";